import React from 'react';
import { withTheme } from 'styled-components'
import { Flex, FlexColumn, LightContainer } from '../../../Reusable/Container'
import { Text, Tag } from '../../../Reusable/Text'
import { Image } from '../../../Reusable/Image'
import { TextButton } from '../../../Reusable/Button'
import { copyToClipboard, getDateInLocalTZ } from '../../../../Utils/util'
import Email from '../../../../Images/email-dark.svg'
import Bank from '../../../../Images/bank-generic.png';
import moment from 'moment'
import hexToRgba from 'hex-to-rgba';

// helpers
const maskAccount = (num) => `•••• ${num.slice(-4)}`;

// Card component
const PaymentMethodCard = ({ isInvite, data, theme, makeDefaultPaymentMethod }) => {
    const isExpired = data?.emailExpiry && moment().isSameOrAfter(moment(data?.emailExpiry).add(1, 'day'), 'day');

    return (
        <LightContainer style={{ marginBottom: 12, height: 98 }}>
            <Flex between>
                {
                    isInvite && <Flex start gap="12px">
                        <Image src={Email} style={{ marginTop: 0 }} />
                        <FlexColumn start left gap="8px">
                            <Flex start centerH gap="12px">
                                <Text size="16px">{data?.emailId ? `Link sent to ${data?.emailId}` : "Link created"}</Text>
                                {
                                    data?.generatedLinkUrl &&
                                    <TextButton weight='400' underline text="Copy link" color="#4F4F7B" onClick={() => copyToClipboard(data?.generatedLinkUrl)} />
                                }
                            </Flex>
                            <Text size="16px">{getDateInLocalTZ(data?.sentDate, 'll')}</Text>
                        </FlexColumn>
                    </Flex>
                }
                {
                    !isInvite &&
                    <FlexColumn start left gap="8px">
                        <Flex start centerH gap="12px">
                            <Image src={isInvite ? Email : (data?.bankDetail?.logoUrl ? data?.bankDetail?.logoUrl : Bank)} style={{ marginTop: 0 }} />
                            <Text size="16px">{data?.bankDetail?.bankName}</Text>
                            {
                                data?.default ?
                                    <Tag background={hexToRgba(theme.colors.primary, 0.1)}>Default</Tag>
                                    :
                                    <TextButton weight='400' underline text="Make default" color="#4F4F7B" onClick={() => makeDefaultPaymentMethod(data)} />
                            }
                        </Flex>
                        <Tag style={{ marginLeft: 36 }}>{maskAccount(data?.bankDetail?.accountNumber)}</Tag>
                    </FlexColumn>
                }
                <Tag>
                    {(() => {
                        switch (true) {
                            case isExpired:
                                return 'Expired';
                            case data?.verificationStatus === 'PROCESSING':
                                return 'Payment Initiated';
                            case data?.verificationStatus === 'REQUESTED':
                                return 'Requested';
                            case data?.verificationStatus === 'VERIFICATION FAILED':
                                return 'Verification Failed';
                            case data?.autoDebitDetails?.validated:
                                return 'Verified';
                            case data?.autoDebitDetails?.verificationStatus === 'PROCESSING':
                                return 'Payment Initiated';
                            case data?.autoDebitDetails?.verificationStatus === 'ERROR':
                                return 'Error';
                            case data?.autoDebitDetails?.verificationStatus === 'VERIFICATION FAILED':
                                return 'Verification Failed';
                            case !data?.autoDebitDetails?.validated:
                                return 'Verification in progress';
                            default:
                                return '';
                        }
                    })()}
                </Tag>
                {/* {
                    !isInvite &&
                    <Flex gap="8px">
                        <Tag primary>ACH</Tag>
                        <Tag>{maskAccount(data?.bankDetail?.accountNumber)}</Tag>
                    </Flex>
                } */}
            </Flex>
        </LightContainer>
    );
};


export default withTheme(PaymentMethodCard);
